import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box
} from '@chakra-ui/react';
import BlockedUsersTable from './BlockedUsersTable';

const BlockedUsersModal = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="6xl">
            <ModalOverlay />
            <ModalContent maxW="90%" maxH="90vh">
                <ModalCloseButton
                    position="absolute"
                    left="8px"
                    right="auto"
                    top="8px"
                    zIndex="3"
                />
                <ModalHeader>
                    משתמשים חסומים
                </ModalHeader>
                <ModalBody pb={6} overflowY="auto">
                    <Box>
                        <BlockedUsersTable />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default BlockedUsersModal;
